var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.84,11.83,8.34.83a1.5,1.5,0,0,0-2.68,0l-5.5,11a1.49,1.49,0,0,0,.06,1.46A1.52,1.52,0,0,0,1.5,14h11a1.52,1.52,0,0,0,1.28-.71A1.49,1.49,0,0,0,13.84,11.83ZM6.25,5a.75.75,0,0,1,1.5,0V8a.75.75,0,0,1-1.5,0ZM7,12a1,1,0,1,1,1-1A1,1,0,0,1,7,12Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusWarning);
export default __webpack_public_path__ + "static/media/status-warning.2c64d4d35e42d9912f92ee3365e10d8a.svg";
export { ForwardRef as ReactComponent };